<div>
	<button *ngFor="let action of actions;" class="btn btn-default text-primary-color-2" (click)="onClick(action)">
		<img src="assets/images/{{ action.icon }}" class="icon-list">
	</button>
</div>